export default function PageHeader({ overline, title, highlight, children, testId }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <div className="min-w-0">
        {overline && <p className="overline mb-2">{overline}</p>}
        <h1
          className="font-display text-4xl md:text-5xl leading-tight tracking-tight"
          data-testid={testId}
        >
          {title}
          {highlight && (
            <>
              {" "}
              <span className="text-gold">{highlight}</span>
            </>
          )}
        </h1>
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}
